import { Auth } from "aws-amplify";
import { Component, FunctionComponent } from "react";
import { Form, Alert, Row, Col } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { AddressDetails, ISetShopAddress } from "../../../client/core";
import { Color, Path, Storage } from "../../../env";
import Autocomplete from "react-google-autocomplete";
import { Button, variant } from "../../form/Button";
import AddressMap from "../../map/AddressMap";

export interface SetShopAddressState {
    search: string;
    error: string;
    addressDetails: AddressDetails;
}

export interface SetShopAddressProps extends RouteComponentProps {
    coreAPI: ISetShopAddress;
    auth: typeof Auth;
}

export default class ShopAddress extends Component<
    SetShopAddressProps,
    SetShopAddressState
> {
    constructor(props: SetShopAddressProps) {
        super(props);
        this.state = {
            search: "",
            error: "",
            addressDetails: {
                id: "",
                address: "",
            },
        };
    }

    handleSearch = (place: google.maps.places.PlaceResult) => {
        const addressDetails: AddressDetails = {
            id: place.place_id!,
            address: place.formatted_address!,
        };
        this.setState({
            addressDetails: addressDetails,
        });
    };

    handleSubmit = () => {
        const shopID = localStorage.getItem(Storage.ShopID);
        if (shopID == null) {
            return this.setState({
                error: "Shop could not be found - please navigate back to the shop dashboard to resync",
            });
        }
        if (this.state.addressDetails.id.trim() === "") {
            return this.setState({
                error: "Please enter the address of your shop and select one of the recommendations",
            });
        }
        this.props.auth.currentSession().then((session) => {
            const token = session.getIdToken().getJwtToken();
            this.props.coreAPI
                .SetShopAddress({
                    identityToken: token,
                    shopID: shopID,
                    addressDetails: {
                        id: this.state.addressDetails.id,
                        address: this.state.addressDetails.address,
                    },
                })
                .then((output) => {
                    if (output.statusCode === 403) {
                        localStorage.removeItem(Storage.ShopID);
                        return this.setState({
                            error: "You were forbidden to change the shop address - please navigate back to the shop dashboard.",
                        });
                    }
                    return this.props.history.push(Path.RegisterShopAccount);
                })
                .catch((err) =>
                    this.setState({
                        error: err.message,
                    })
                );
        });
    };

    render() {
        const props: SetShopAddressFormProps = {
            search: this.state.search,
            error: this.state.error,
            apiKey: process.env.REACT_APP_CORE_GOOGLE_PLACES_KEY!,
            selectedAddress: this.state.addressDetails,
            onSubmit: this.handleSubmit,
            onChange: this.handleSearch,
        };
        return <SetShopAddressForm {...props} />;
    }
}

export interface SetShopAddressFormProps {
    search: string;
    error: string;
    apiKey: string;
    selectedAddress: AddressDetails;
    onSubmit: () => void;
    onChange: (place: google.maps.places.PlaceResult) => void;
}

export const SetShopAddressForm: FunctionComponent<SetShopAddressFormProps> = (
    props
) => (
    <Form>
        <h1 style={{ marginBottom: "2rem" }}>Enter your location</h1>
        <Alert variant={"danger"} show={props.error != ""}>
            {props.error}
        </Alert>
        <Form.Group>
            <Form.Label>Shop Address</Form.Label>
            <Autocomplete
                apiKey={props.apiKey}
                onPlaceSelected={(place) => props.onChange(place)}
                style={{
                    width: "100%",
                    padding: ".375rem .75rem",
                    borderRadius: ".25rem",
                    border: "1px solid #ced4da",
                }}
                options={{
                    types: ["address"],
                }}
            />
            <Button
                id="set-shop-address-submit-btn"
                buttonvariant={variant.Primary}
                style={{ width: "100%", marginTop: "2rem" }}
                name={"Continue"}
                onClick={() => props.onSubmit()}
            />
        </Form.Group>
    </Form >
);
